export default {
  YOUR_EVENTS: 'Uw evenementen',
  ADD_EVENTS: 'Evenement toevoegen',
  NO_EVENTS: 'Je hebt nog geen evenementen toegevoegd!',
  ENTER: 'Binnenkomen',
  EVENT_NAME: 'Naam van het evenement',
  START_DATE: 'Begindatum',
  END_DATE: 'Einddatum',
  LOCATION: 'Plaats',
  TIMEZONE: 'Tijdzone',
  EVENT_CONFIG: 'Configuratie van evenementen',
  API_KEY: 'API-sleutel',
  ARCHIVE_DAYS: 'Archief Dagen',
  ARCHIVE_DAYS_LABEL: 'Dagen om te archiveren na afloop van het evenement',
  GDPR_CONFIG: 'GDPR-configuratie',
  GDPR_CONSENT: 'GDPR -toestemming',
  GDPR_TITLE: 'Titel van de GDPR',
  GDPR_DESC: 'GDPR -beschrijving',
  GDPR_APPROVE_LABEL: 'GDPR -knoplabel goedkeuren',
  GDPR_CANCEL_LABEL: 'Label van de GDPR -knop Annuleren',
  ADD_EVENT: 'Evenement toevoegen',
  ADD_EVENT_SUCCESS: 'Uw evenement is succesvol aangemaakt!'
}
